import { createQueryKeys } from '@lukemorales/query-key-factory';
import { fetchLogoWall } from '@fe-news/actions/logo-wall';

const logoWallByType = (type: string) => ({
  queryKey: [type] as [string],
  queryFn: () => fetchLogoWall(type)
});

const logoWall = createQueryKeys('logoWall', {
  logoWallByType
});

export default logoWall;
